module.exports = __webpack_public_path__ + "img/sway-visa-background-logo.de77350c.svg";